import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import HistoryIcon from '@mui/icons-material/History';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import DateLabel from '../../../label/DateLabel';
import { SectionLabel } from './taskCardUi';

// history entries carry a type ("created" | "updated" | "deleted") and the
// field they refer to in text (e.g. "priority")
const historyIconMap = {
  created: AddCircleOutlineIcon,
  updated: EditOutlinedIcon,
  deleted: DeleteOutlineIcon,
  comment: ChatBubbleOutlineIcon,
};

const VISIBLE_ENTRIES = 5;

const TaskCardHistory = ({ history = [] }) => {
  const { t } = useTranslation();

  const [showAll, setShowAll] = useState(false);

  if (!history.length) return null;

  const visibleHistory = showAll ? history : history.slice(0, VISIBLE_ENTRIES);

  return (
    <Box className="flex flex-col gap-2">
      <SectionLabel>{t('History')}</SectionLabel>
      <Box className="flex flex-col">
        {visibleHistory.map((entry) => {
          const Icon = historyIconMap[entry.type] || HistoryIcon;
          return (
            <Box key={entry.id} className="flex items-center gap-2 py-1">
              <Icon sx={{ fontSize: '14px', opacity: 0.5 }} />
              {/* mobile has no room for name and action side by side */}
              <Box className="flex flex-col md:flex-row md:items-center md:gap-2 grow min-w-0">
                <Typography fontSize="10px" fontWeight={600}>
                  {`${entry.user?.firstName || ''} ${
                    entry.user?.lastName || ''
                  }`.trim()}
                </Typography>
                <Typography fontSize="10px" className="opacity-60">
                  {`${t(entry.text)}`}
                </Typography>
              </Box>
              <Typography
                fontSize="10px"
                className="opacity-50 whitespace-nowrap"
              >
                <DateLabel date={entry.createdAt} />
              </Typography>
            </Box>
          );
        })}
      </Box>

      {history.length > VISIBLE_ENTRIES && (
        <Button
          size="small"
          onClick={() => setShowAll(!showAll)}
          sx={{ alignSelf: 'center', fontSize: '11px' }}
        >
          {showAll
            ? t('show less...')
            : `${t('show more...')} (${history.length - VISIBLE_ENTRIES})`}
        </Button>
      )}
    </Box>
  );
};

export default TaskCardHistory;
